import React from 'react'
import { Link } from 'react-router-dom';
import Bannerbg0 from '../../assets/images/wills.png';
// import Bannerbg from '';
import Slider from 'react-slick';

const Bannerone = () => {
    const Bannerslider = {
        dots: true,
        infinite: true,
        speed: 200,
        autoplay: true,
        autoplaySpeed: 6000,
        slidesToShow: 1,
        fade: true,
        arrows: false,
        slidesToScroll: 1
    }
    return (
        <section className="banner-one">
            <div className="container-fluid p-0">
                <Slider className="banner-one-slider" {...Bannerslider}>
                    <div className="banner-one-slider-item">
                        <div className="banner-one-slider-item-image zoom-in">
                            <img
                                src={Bannerbg0}
                                alt="banner-images"
                            />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-7 col-lg-8 col-md-10">
                                    <div className="banner-one-info" id='banner-one-info'>
                                        <div className="banner-title fade-left hero">
                                            <h1>Execute your Indian will from anywhere in world.</h1>
                                        </div>
                                        <div className="section-details fade-left head">
                                            <h3 className='text-white' >
                                            No travel. No hassles. 100% legal. 100% secure.
                                            </h3>
                                        </div>
                                        {/* <div className="fade-in-up">
                                            <Link to="/contact-us" className="btn btn-primary" data-discover="true">
                                                Contact Us
                                                <i className="flaticon-next" />
                                            </Link>
                                        </div> */}
                                    </div>
                                </div>
                                {/* <div className="banner-one-box">
                                    <div className="banner-one-box-inner">
                                        <i className="flaticon-money-bag" />
                                        <h2>5% Interest</h2>
                                    </div>
                                    <p>
                                        Discover our dependable loan solutions designed to empower your
                                        financial journey.
                                    </p>
                                </div> */}
                            </div>
                        </div>
                    </div>
                    {/* <div className="banner-one-slider-item">
                        <div className="banner-one-slider-item-image zoom-in">
                            <img
                                src={Bannerbg}
                                alt="banner-images"
                            />
                        </div>
                        <div className="container">
                            <div className="row">
                                <div className="col-xl-7 col-lg-8 col-md-10">
                                    <div className="banner-one-info">
                                        <div className="banner-title fade-left">
                                            <h1>NRI issues resolved. With peace of mind and confidence</h1>
                                        </div>
                                        <div className="section-details fade-left">
                                            <p>
                                            Where passion meets expertise, and every client feels like family. Think of us as your full-support solutions arm - because distance shouldn't come in the way of peace of mind.
                                            </p>
                                        </div>
                                        <div className="fade-in-up">
                                            <Link to="/Contactus" className="btn btn-primary">
                                                Contact Us
                                                <i className="flaticon-next" />
                                            </Link>
                                        </div>
                                    </div>
                                </div>
                                <div className="banner-one-box">
                                    <div className="banner-one-box-inner">
                                        <i className="flaticon-money-bag" />
                                        <h2>5% Interest</h2>
                                    </div>
                                    <p>
                                        Discover our dependable loan solutions designed to empower your
                                        financial journey.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </Slider>
            </div>
        </section>
    )
}
export default Bannerone;